import React from 'react';

import {FinancialHistoryTable} from '../components';
import type {IFinancialHistorySubStepProps} from '../financials.types';

export const FinancialHistorySubStep: React.FC<
  IFinancialHistorySubStepProps
> = ({
  financialHistoryStatus,
  financialSummaries,
  isSavingFinancialHistory,
  yearOptions,
  monthOptions,
  onSummaryFieldChange,
}) => (
  <div className="financials-summary-step">
    <div className="sr-only" role="status" aria-live="polite">
      {financialHistoryStatus}
    </div>

    <FinancialHistoryTable
      financialSummaries={financialSummaries}
      isSavingFinancialHistory={isSavingFinancialHistory}
      yearOptions={yearOptions}
      monthOptions={monthOptions}
      onSummaryFieldChange={onSummaryFieldChange}
    />
  </div>
);
